export default __webpack_public_path__ + "static/media/ChinWei-Lim.35d5369a.png";